module.exports = __webpack_public_path__ + "static/media/light.7b1b65a2.png";